import React, { useMemo, Fragment, useEffect, useState, useRef } from 'react';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import RightTable from './RightTable';
import LeftTable from './LeftTable';
import Grid from '@mui/material/Grid';
import pullAll from "lodash/pullAll"
import KeyboardDoubleArrowRightIcon from '@mui/icons-material/KeyboardDoubleArrowRight';
import KeyboardDoubleArrowLeftIcon from '@mui/icons-material/KeyboardDoubleArrowLeft';
import Typography from '@mui/material/Typography';


const MpgClientCodeTransferListDialogForClientSubAcc = ({ open, setOpen, leftTableDataToPop, rightTableDataToPop, grabRightTableData, transferDialogTitle, leftTableTitle, rightTableTitle }) => {

    /** */
    const [leftTableData, setLeftTableData] = useState([])
    const [rightTableData, setRightTableData] = useState([])


    // console.log("rightTableDataToPop1:", rightTableDataToPop)

    /**populating if existing data is provided by user for table */
    useEffect(() => {
        if (!!rightTableDataToPop && !!rightTableDataToPop.length) {
            setRightTableData(rightTableDataToPop)
        } else {
            setRightTableData([])
        }
    }, [rightTableDataToPop])

    useEffect(() => {
        if (!!leftTableDataToPop && !!leftTableDataToPop.length) {
            setLeftTableData(leftTableDataToPop)
        } else {
            setLeftTableData([])
        }
    }, [leftTableDataToPop])

    /**selected row items */
    const [rightTableRowSelection, setRightTableRowSelection] = useState({});
    const [leftTableRowSelection, setLeftTableRowSelection] = useState({});

    /** */
    const [selectedItemsInLeft, setSelectedItemsInLeft] = useState([])
    const [selectedItemsInRight, setSelectedItemsInRight] = useState([])

    const trasferToRightHandler = () => {

        /**transferring actual entries to right */
        if (!!rightTableData && !!rightTableData.length) {
            setRightTableData([...rightTableData, ...selectedItemsInLeft])
        } else {
            setRightTableData(selectedItemsInLeft)
        }

        /**we do not remover trasfer entries from left instead we disable selection of those */
        /**to avoid duplicate selection we disable selection of tranfered row*/

        /**clearing check box in left table on trasfer */
        setLeftTableRowSelection({})
    }


    const trasferToLeftHandler = () => {
        /**here we r not trasferring actual item. We unable check box which can be selectable. */

        /**removing selected items from right table */
        const rightCopy = [...rightTableData]
        pullAll(rightCopy, selectedItemsInRight)
        setRightTableData(rightCopy)

        /**clearing check box in right table on trasfer */
        setRightTableRowSelection({})
    }

    /** */
    const handleClose = (event, reason) => {
        if (reason && reason == "backdropClick") {
            return '';
        } else {
            setOpen(false);
        }
    }

    // console.log("gl-rightTableData", rightTableData)

    return (
        <Dialog
            open={open}
            onClose={handleClose}
            disableEscapeKeyDown
            fullScreen
        >
            <DialogTitle sx={{ display: 'flex', alignItems: 'center' }}>
                <Typography align='center' sx={{ fontWeight: 'bolder', fontSize: '20px' }}>
                    {transferDialogTitle}
                </Typography>

                <IconButton
                    sx={{ ml: 'auto' }}
                    onClick={handleClose}
                >
                    <CloseIcon />
                </IconButton>
            </DialogTitle>
            <DialogContent>

                <Grid container spacing={1}>
                    {/**left table */}

                    <Grid item xs={12} sm={5}>
                        <Typography variant="subtitle2" align='center' sx={{ fontWeight: 'bolder' }}>
                            {leftTableTitle}
                        </Typography>
                        <LeftTable
                            leftTableData={leftTableData}

                            setSelectedItemsInLeft={setSelectedItemsInLeft}

                            leftTableRowSelection={leftTableRowSelection}
                            setLeftTableRowSelection={setLeftTableRowSelection}

                            rightTableData={rightTableData}
                        />
                    </Grid>
                    <Grid item xs={12} sm={2}>
                        <Grid
                            container
                            direction="column"
                            justifyContent="center"
                            alignItems="center"
                        >

                            <Button
                                variant="outlined"
                                onClick={() => {
                                    trasferToRightHandler();
                                }}
                                disabled={!!selectedItemsInRight.length}
                            ><KeyboardDoubleArrowRightIcon /></Button>
                            <br />
                            <Button
                                variant="outlined"
                                onClick={() => {
                                    trasferToLeftHandler();
                                }}
                                disabled={!!selectedItemsInLeft.length}
                            ><KeyboardDoubleArrowLeftIcon /></Button>
                        </Grid>

                    </Grid>
                    {/**right table */}
                    <Grid item xs={12} sm={5}>
                        <Typography variant="subtitle2" align='center' sx={{ fontWeight: 'bolder' }}>
                            {rightTableTitle}
                        </Typography>
                        <RightTable
                            rightTableData={rightTableData}
                            setSelectedItemsInRight={setSelectedItemsInRight}

                            rightTableRowSelection={rightTableRowSelection} setRightTableRowSelection={setRightTableRowSelection}
                        />
                    </Grid>
                </Grid>

            </DialogContent>
            <DialogActions>
                <Button
                    type='button'
                    onClick={() => {
                        grabRightTableData(rightTableData || [])
                        handleClose()
                    }}
                >Add</Button>
                <Button onClick={handleClose}>Cancel</Button>
            </DialogActions>

        </Dialog >
    )
}
export default MpgClientCodeTransferListDialogForClientSubAcc